import angular from 'angular';
import compliantMembersComponent from './compliant-members.component';

export default angular.module('components.app.member-compliance.compliant-members', [])
  .component('compliantMembers', compliantMembersComponent)
  .name;



// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/compliant-members/compliant-members.module.js